/**
 * @flow
 * @relayHash 66c6dd63d90bfd9af7441df90437dca5
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type Main_viewer$ref = any;
export type ArticleStateType = "available" | "deleted" | "draft" | "%future added value";
export type queries_MainPage_QueryVariables = {|
  page: number,
  states?: ?$ReadOnlyArray<?ArticleStateType>,
|};
export type queries_MainPage_QueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: Main_viewer$ref
  |}
|};
export type queries_MainPage_Query = {|
  variables: queries_MainPage_QueryVariables,
  response: queries_MainPage_QueryResponse,
|};
*/


/*
query queries_MainPage_Query(
  $page: Int!
  $states: [ArticleStateType]
) {
  viewer {
    ...Main_viewer_in1hr
    id
  }
}

fragment Main_viewer_in1hr on Viewer {
  articles: articlesPaginate(pageSize: 12, page: $page, states: $states) {
    totalCount
    articles {
      id
      title
      sectionName
      section
      availableAt
      state
      authorName
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "page",
    "type": "Int!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "states",
    "type": "[ArticleStateType]",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "queries_MainPage_Query",
  "id": null,
  "text": "query queries_MainPage_Query(\n  $page: Int!\n  $states: [ArticleStateType]\n) {\n  viewer {\n    ...Main_viewer_in1hr\n    id\n  }\n}\n\nfragment Main_viewer_in1hr on Viewer {\n  articles: articlesPaginate(pageSize: 12, page: $page, states: $states) {\n    totalCount\n    articles {\n      id\n      title\n      sectionName\n      section\n      availableAt\n      state\n      authorName\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "queries_MainPage_Query",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "Main_viewer",
            "args": [
              {
                "kind": "Variable",
                "name": "page",
                "variableName": "page",
                "type": null
              },
              {
                "kind": "Variable",
                "name": "states",
                "variableName": "states",
                "type": null
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "queries_MainPage_Query",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": "articles",
            "name": "articlesPaginate",
            "storageKey": null,
            "args": [
              {
                "kind": "Variable",
                "name": "page",
                "variableName": "page",
                "type": "Int"
              },
              {
                "kind": "Literal",
                "name": "pageSize",
                "value": 12,
                "type": "Int"
              },
              {
                "kind": "Variable",
                "name": "states",
                "variableName": "states",
                "type": "[ArticleStateType]"
              }
            ],
            "concreteType": "ArticlesPagination",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "totalCount",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "articles",
                "storageKey": null,
                "args": null,
                "concreteType": "Article",
                "plural": true,
                "selections": [
                  v1,
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "title",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "sectionName",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "section",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "availableAt",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "state",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "authorName",
                    "args": null,
                    "storageKey": null
                  }
                ]
              }
            ]
          },
          v1
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'd99922ca9759bc8ad2d320246220100e';
module.exports = node;



// WEBPACK FOOTER //
// src/__generated__/queries_MainPage_Query.graphql.js